global.window.Macy = require('./thirdparty/macy/macy.min');

let macy,
  hasMacyRun = false,
  macyRmTimeout,
  macyCalcTimeout;

if (document.querySelector('footer .footer__list') && (typeof Macy !== 'undefined')) {
  $(window).on('resize', () => {
    if (window.innerWidth >= 680 && !hasMacyRun) {
      macy = Macy({
        container: '.footer__list',
        columns: 4,
        margin: 10,
        breakAt: {
          680: {
            columns: 1
          }
        }
      })

      clearTimeout(macyCalcTimeout);
      macyCalcTimeout = setTimeout(() => {
        if (macy) {
          macy.recalculate(true);
        }
      }, 100)

      hasMacyRun = true;
    }

    if (window.innerWidth < 680 && hasMacyRun && macy) {
      macy.remove();
      clearTimeout(macyRmTimeout);
      macyRmTimeout = setTimeout(() => {
        $('.footer__list').removeAttr('style');
        $('.footer__col').removeAttr('style');
      }, 100);
      hasMacyRun = false;
    }
  }).trigger('resize');
}
